import { render, staticRenderFns } from "./DecorDetailForm.vue?vue&type=template&id=7d2b07d4&scoped=true"
import script from "./DecorDetailForm.vue?vue&type=script&lang=js"
export * from "./DecorDetailForm.vue?vue&type=script&lang=js"
import style0 from "./DecorDetailForm.vue?vue&type=style&index=0&id=7d2b07d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2b07d4",
  null
  
)

export default component.exports